module.exports = __webpack_public_path__ + "img/depmap_svg_V184.828252f5.svg";